import React from 'react';
import { DataExtracts } from './embeddedSvgs/DataExtractsIcon';
import { ReportsIcon } from './embeddedSvgs/ReportsSvg';
import { DocumentsCheckIcon } from './embeddedSvgs/DocumentsCheckIcon';
import { DocumentCandidateSearch } from './embeddedSvgs/DocumentCandidateSearchIcon';
import { JobApplication } from './embeddedSvgs/JobApplicationIcon';
import { Invoice } from './embeddedSvgs/InvoiceIcon';
import { TimeExpenses } from './embeddedSvgs/TimeExpensesIcon';
import { AddTimeIcon } from './embeddedSvgs/AddTimeIcon';
import { TwitterIcon } from './embeddedSvgs/TwitterIcon';
import { FacebookIcon } from './embeddedSvgs/FacebookIcon';
import { LinkedInIcon } from './embeddedSvgs/LinkedInIcon';
import { AddExpenseIcon } from './embeddedSvgs/AddExpenseIcon';
import { FactCheckIcon } from './embeddedSvgs/FactCheck';
import { JobPostingIcon } from './embeddedSvgs/JobPostingIcon';
import { PaidIcon } from './embeddedSvgs/PaidIcon';
import { TimeAllocationIcon } from './embeddedSvgs/TimeAllocationIcon';

export type EmbeddedSvgNames =
  | 'data_extracts_custom'
  | 'reports_custom'
  | 'documents_check_custom'
  | 'document_candidate_search_custom'
  | 'job_application_custom'
  | 'invoice_custom'
  | 'time_expense_custom'
  | 'add_time_custom'
  | 'facebook_custom'
  | 'linked_in_custom'
  | 'twitter_custom'
  | 'add_expense_custom'
  | 'fact_check_custom'
  | 'job_posting_custom'
  | 'paid_custom'
  | 'time_allocation_custom';

// Export all embedded svgs basde on the EmbeddedSvgNames
export const allEmbeddedSvgs: { [key in EmbeddedSvgNames]: React.JSX.Element } = {
  data_extracts_custom: <DataExtracts />,
  reports_custom: <ReportsIcon />,
  documents_check_custom: <DocumentsCheckIcon />,
  document_candidate_search_custom: <DocumentCandidateSearch />,
  job_application_custom: <JobApplication />,
  invoice_custom: <Invoice />,
  time_expense_custom: <TimeExpenses />,
  add_time_custom: <AddTimeIcon />,
  twitter_custom: <TwitterIcon />,
  facebook_custom: <FacebookIcon />,
  linked_in_custom: <LinkedInIcon />,
  add_expense_custom: <AddExpenseIcon />,
  fact_check_custom: <FactCheckIcon />,
  job_posting_custom: <JobPostingIcon />,
  paid_custom: <PaidIcon />,
  time_allocation_custom: <TimeAllocationIcon />
};
